import {StudyPhase} from 'graphql-client/__generated/graphqlGlobalTypes';

const STUDY_PHASE_TO_PROCEED_TEXT: Record<StudyPhase, string> = {
  [StudyPhase.DESIGN]: 'Proceed to design',
  [StudyPhase.EXECUTION]: 'Proceed to execution',
  [StudyPhase.COMPLETE]: 'Proceed to completion',
};

const STUDY_PHASE_TO_RETURN_TEXT: Record<StudyPhase, string> = {
  [StudyPhase.DESIGN]: 'Return to design phase',
  [StudyPhase.EXECUTION]: 'Return to execution phase',
  [StudyPhase.COMPLETE]: 'Return to completed study',
};

export function getProceedTextForStudyPhase(studyPhase: StudyPhase): string {
  return STUDY_PHASE_TO_PROCEED_TEXT[studyPhase];
}

export function getReturnTextForStudyPhase(studyPhase: StudyPhase): string {
  return STUDY_PHASE_TO_RETURN_TEXT[studyPhase];
}

interface TrialSampleTestingStudyDesignNode {
  treatmentGroups: Array<unknown>;
  sampleDefinitions: Array<unknown>;
  sampleTestPlans: Array<unknown>;
}

export const isProceedtoExecutionBlocked = (
  studyDesign: TrialSampleTestingStudyDesignNode | null,
  phase: StudyPhase
): boolean => {
  if (studyDesign == null) {
    return false;
  }
  const {treatmentGroups, sampleDefinitions, sampleTestPlans} = studyDesign;
  /**
   * Realistically, the study design will never be in an incomplete state because the design
   * cannot be saved if it is incomplete. However, this function covers additional cases just in case.
   */
  const isStudyDesignIncomplete =
    treatmentGroups.length === 0 || sampleDefinitions.length === 0 || sampleTestPlans.length === 0;
  return phase === StudyPhase.DESIGN && isStudyDesignIncomplete;
};
